import { render, staticRenderFns } from "./AssignConfigEditNew.vue?vue&type=template&id=21a3daae&scoped=true"
import script from "./AssignConfigEditNew.vue?vue&type=script&lang=js"
export * from "./AssignConfigEditNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a3daae",
  null
  
)

export default component.exports